// Products that live on their own site or in the App Store instead of a
// /products/<slug> page on this site.
export const EXTERNAL_PRODUCT_URLS: Record<string, string> = {
  sight: "https://sight.cero-ai.com",
  skyline: "https://apps.apple.com/de/app/skyline-spotter/id6790389804",
  foody: "https://getfoody.app",
};

export const OCD_REPO_URL = "https://github.com/0-AI-UG/open-cli-deployment";
